module.exports = __webpack_public_path__ + "img/banner.29bea43b.png";